export default __webpack_public_path__ + "static/media/11t.9f3d0031.jpg";